import { render, staticRenderFns } from "./SwapButton.vue?vue&type=template&id=70317107&scoped=true"
var script = {}
import style0 from "./SwapButton.vue?vue&type=style&index=0&id=70317107&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70317107",
  null
  
)

export default component.exports